module.exports = __webpack_public_path__ + "static/img/49.4.50.198.6ee3e2ef.png";